export default __webpack_public_path__ + "static/media/sin-huevos.c6946c1c.svg";